import { render, staticRenderFns } from "./ArchivioFileConvertiti.vue?vue&type=template&id=152808d5&scoped=true"
import script from "./ArchivioFileConvertiti.vue?vue&type=script&lang=js"
export * from "./ArchivioFileConvertiti.vue?vue&type=script&lang=js"
import style0 from "./ArchivioFileConvertiti.vue?vue&type=style&index=0&id=152808d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152808d5",
  null
  
)

export default component.exports